<template>
  <div class="mb-4">
    <div class="" v-if="isAuthenticated">
      <div>
        <h6 class="fw-bold">
          {{ 'Account information' | translate }}
        </h6>
      </div>
      <div class="d-flex">
        <div>
          {{ 'Logged in as' | translate }}
          <b>{{ student.email }}</b>
        </div>
        <div class="ms-auto">
          <a href="#" id="logout" class="" @click.prevent="logout">
            {{ 'Logout' | translate }}
          </a>
        </div>
      </div>
    </div>

    <div class="" v-else-if="!isAuthenticated">
      <div class="d-flex align-items-baseline">
        <h6 class="fw-bold mb-0 d-flex">
          {{ 'User information' | translate }}
        </h6>

        <div class="ms-auto">
          <Login ref="login"></Login>
        </div>
      </div>
      <div class="mb-2 small text-muted">
        {{ 'Required to create your profile on the platform' | translate }}.
      </div>
      <div>
        <Register></Register>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './Login'
import Register from './Register'
import api from '../../helpers/api'

export default {
  components: {
    Login,
    Register,
  },
  methods: {
    tooltipStart(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).show()
    },
    tooltipStop(event) {
      bootstrap.Tooltip.getOrCreateInstance(event.target).hide()
    },
    setView(view) {
      this.$store.commit('setView', view)
    },

    logout() {
      axios.post('/checkout/logout').then((response) => {
        location.reload()
      })
    },

    async fetchUser() {
      try {
        const response = await api.getStudent()
        this.$store.commit('login', response.data)
      } catch (error) {}
    },
  },
  computed: {
    student() {
      return this.$store.state.user
    },
    view() {
      return this.$store.state.view
    },
    isAuthenticated() {
      return this.$store.state.user.email ? true : false
    },
  },
}
</script>

<style></style>
